import { message, Modal, Segmented, Spin } from "antd";
import { Col, Row } from "react-bootstrap";
import { StyledTable } from "atoms/Table";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { ReactComponent as Dateicon } from "../../assets/icons/Vector.svg";
import dayjs from "dayjs";
import COLORS from "common/Colors";
import { useSelector } from "react-redux";
import { getLocations, getUserList, getCountryTimezoneList } from "redux/selectors";
import { RightOutlined } from "@ant-design/icons";
import { ButtonFilled } from "reusableComponent/UIButtons";
import AppraisalHistory from "./AppraisalHistory";
import { STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
import { ReactComponent as FolderIcon } from "../../assets/icons/FolderIcon.svg";
import user from "../../assets/employeeinfo.svg";
import { EmployeeInfo } from "./EmployeeInfo";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import axios from "axios";
dayjs.extend(timezone);
dayjs.extend(utc);

const SegmentWrap = styled(Segmented)`
  position: sticky;
  top: 40px;
  float: right;
  background-color: #fff;
  z-index: 100;
  border: 1px solid #ffffff;
  color: #636980;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  .ant-segmented-item-selected {
    background-color: #c2fae5 !important;
    color: black;
  }
`;

const StyledDiv = styled.div`
  .wrapped-header {
    white-space: normal !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
`;

const AwaitingAppraiseeRespons = () => {
  const locationList = useSelector(getLocations);
  const CountryTimezone = useSelector(getCountryTimezoneList);
  const userInfo = useSelector((state) => state?.user?.userInfo) || {};
  const history = useHistory();
  const location = useLocation();
  const appraisalRecord = history?.location?.state?.appraisalRecord || {};
  const [allAppraisalData, setAllAppraisalData] = useState([]);
  const [appraisalDetails, setAppraisalDetails] = useState({});
  const [segmentedData, setSegmentData] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [softSkillData, setSoftSkillData] = useState([]);
  const [technicalAssessmentData, setTechnicalAssessmentData] = useState([]);
  const [rolledOverData, setRolledoverData] = useState([]);
  const [upcomingData, setUpcomingData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userList = useSelector((state) => getUserList(state)) || [];
  const [historyData, setHistoryData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [loader, setLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);

  const showModal = () => setIsModalVisible(true);
  const handleCancelModal = () => setIsModalVisible(false);

  const getData = async () => {
    const { code, response, performanceContractList } = await CALL_API(
      `appraisal/history?appraiseemailid=${appraisalRecord?.userid}`,
      "get",
      {}
    );
    if (code === STATUS_CODE?.SUCCESS) {
      setHistoryData(performanceContractList);
    }
  };

  const transformStrategicObjectives = (data) => {
    return data?.map((item, index) => ({
      key: `strategic-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item.straobjorgstartegy || "-",
      ExpectedOutcomes: item.expectedoutcome || "-",
      TargetDate: item?.TargetDate || "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const transformRolloverResponsibility = (data) => {
    return data?.map((item, index) => ({
      key: `rollover-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item.previousappraisalperiod || "-",
      ExpectedOutcomes: item.expectedoutcome || "-",
      TargetDate: item?.TargetDate || "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const transformUpcomingAppraisal = (data) => {
    return data?.map((item, index) => ({
      key: `upcoming-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item.upcomingappraisalperiod || "-",
      ExpectedOutcomes: item.expectedoutcome || "-",
      TargetDate: item?.TargetDate || "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const handleSegmentChange = (value) => {
    // const index = appraisalInformation?.findIndex(
    //   (item) => item.roletype === value
    // );
    // setSelectedSegment(value);
    // setAppraisalIndex(index + 1);
    // setCompletedSegment((prev) => {
    //   if (!prev.includes(index)) {
    //     return [...prev, index - 1];
    //   }
    //   return prev;
    // });
  };

  const getColumns = (objectiveTitle) => [
    {
      title: "S.No",
      dataIndex: "Slno",
      key: "Slno",
    },
    {
      title: objectiveTitle,
      dataIndex: "Targetobjectives",
      key: "Targetobjectives",
      className: "wrapped-header",
      width: "30%",
    },
    {
      title: "Expected Outcomes",
      dataIndex: "ExpectedOutcomes",
      key: "ExpectedOutcomes",
      className: "wrapped-header",
      width: "30%",
    },
    {
      title: "Target Date",
      dataIndex: "TargetDate",
      key: "TargetDate",
      render: (text) => (
        <>
          <Dateicon style={{ marginRight: "10px" }} />
          {moment(text).format("DD-MM-YYYY")}
        </>
      ),
    },
    {
      title: "Weightage",
      dataIndex: "Weightage",
      key: "Weightage",
      align: "center",
    },
  ];

  const dataColumns = [
    {
      title: "Objectives",
      dataIndex: "objective",
      key: "objective",
    },
    {
      title: "Weightage (%)",
      dataIndex: "weightage",
      key: "weightage",
    },
  ];

  const getDetails = async () => {
    const { code, response, performanceContractList } = await CALL_API(
      `appraisal/appraiseemine?userid=${appraisalRecord?.userid}`,
      "get",
      {}
    );

    if (code === STATUS_CODE?.SUCCESS) {
      const totalAppraisal = userList
        ?.find((val) => val?.userid === appraisalRecord?.userid)
        ?.appraisalInformation?.filter((item) => item?.appraisal === "Yes");

      const appraiserid = totalAppraisal?.map((user) => user?.appraiser);
      setAllAppraisalData(
        performanceContractList?.filter((val) =>
          appraiserid?.includes(val?.apraisercreatedby)
        )
      );
      const filtered = performanceContractList?.filter(
        (item) =>
          item?.performanceid === appraisalRecord?.performanceid &&
          appraiserid?.includes(item?.apraisercreatedby)
      );

      const totalAppraisalData =
        userList
          ?.find((item) => item?.userid === appraisalRecord?.userid)
          ?.appraisalInformation?.map((val, index) => {
            return {
              contractid: `New-${index}`,
              roletype: val?.roletype,
            };
          }) || [];

      const segmentedData = filtered?.map((item) => ({
        roletype: item?.roletype,
        contractid: item.contractid,
      }));

      const sortedSegmentedData = [...segmentedData].sort((a, b) => {
        // Force appraisalRecord.contractid to the top
        if (a.contractid === appraisalRecord.contractid) return -1;
        if (b.contractid === appraisalRecord.contractid) return 1;

        const roleA = a.roletype?.toLowerCase() || "";
        const roleB = b.roletype?.toLowerCase() || "";

        if (roleA === "primary" && roleB !== "primary") return -1;
        if (roleB === "primary" && roleA !== "primary") return 1;

        const numberA = parseInt(roleA.match(/\d+/)?.[0], 10) || 0;
        const numberB = parseInt(roleB.match(/\d+/)?.[0], 10) || 0;

        return numberA - numberB;
      });
      const mergedSegmentedData = [
        ...sortedSegmentedData,
        ...totalAppraisalData.filter(
          (val) =>
            !sortedSegmentedData.some((item) => item.roletype === val.roletype)
        ),
      ];
      setSegmentData(mergedSegmentedData);

      setSelectedSegment(mergedSegmentedData[0]?.contractid);
      setSelectedEmployee(
        userList?.find((item) => item?.userid === appraisalRecord?.userid)
      );
    }
  };

  useEffect(() => {
    getDetails();
    getData();
  }, [appraisalRecord?.contractid]);

  useEffect(() => {
    const filtered = allAppraisalData?.filter(
      (item) => item?.contractid === selectedSegment
    );
    setAppraisalDetails(filtered[0]);
    setSoftSkillData(
      filtered[0]?.softskills?.map((item, index) => {
        return { ...item, id: index + 1 };
      })
    );
    setTechnicalAssessmentData(
      transformStrategicObjectives(filtered[0]?.startegicobjectives)
    );
    setRolledoverData(
      transformRolloverResponsibility(filtered[0]?.rolloverresponsibility)
    );
    setUpcomingData(
      transformUpcomingAppraisal(filtered[0]?.upcomingappraisalperiod)
    );
  }, [selectedSegment, allAppraisalData]);

  const finduser = userList?.find((item) => item?.userid === userInfo?.userid);

  const findtimeZone = CountryTimezone?.filter(
    (item) => item?.country === finduser?.managingoffice[0]
  );

  const WorkInfoDetails = [
    // {
    //   data: "Overtime Eligible",
    //   value: appraisalDetails?.overtimestatus || "-",
    // },
    // {
    //   data: "Overtime Eligible",
    //   value: appraisalDetails?.overtimestatus || "-",
    // },
    {
      data: "Name of the employee",
      value: appraisalRecord?.fullname || "-",
    },
    {
      data: "Period",
      value: appraisalDetails?.period || "-",
    },
    {
      data: "Start date to attend appraisal",
      value: appraisalDetails?.attendstartdate
        ? moment(appraisalDetails?.attendstartdate, "YYYY-MM-DD").format(
            "DD-MM-YYYY"
          )
        : "-",
    },
    {
      data: "End date to attend appraisal",
      value: appraisalDetails?.attendenddate
        ? moment(appraisalDetails?.attendenddate, "YYYY,MM-DD").format(
            "DD-MM-YYYY"
          )
        : "-",
    },
    {
      data: "Employee ID",
      value: appraisalRecord?.employeeid || "-",
    },
    {
      data: "Managing Office",
      value:
        typeof appraisalRecord?.managingoffice === "string"
          ? appraisalRecord?.managingoffice
            ? [appraisalRecord?.managingoffice]
            : "-"
          : appraisalRecord?.managingoffice?.join(", ") || "-",
    },
    {
      data: "Grade",
      value: appraisalRecord?.grade || "-",
    },
    {
      data: "Location",
      value:
        locationList?.find(
          (item) => item.location_id === appraisalRecord?.levellocationid
        )?.location_name || "-",
    },
    {
      data: "Department",
      value: appraisalRecord?.leveldepartmentname || "-",
    },
    {
      data: "Contracting Company",
      value: appraisalRecord?.companyname || "-",
    },
    {
      data: "Designation",
      value: appraisalRecord?.designation || "-",
    },

    {
      data: "Hired Date",
      value: appraisalRecord?.hireddate
        ? moment(appraisalRecord?.hireddate).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Professional Since",
      value: appraisalRecord?.professionalsince
        ? moment(appraisalRecord?.professionalsince).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Target Chargeability %",
      value: appraisalRecord?.targetchargeability || "-",
    },
    {
      data: "Charge Out Rate",
      value: appraisalRecord?.chargeoutrate || "-",
    },
    {
      data: "Last Promotion Date",
      value: appraisalRecord?.lastpromotionlevel
        ? moment(appraisalRecord?.lastpromotionlevel).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Last Promotional Level",
      value: appraisalRecord?.lastpromotion
        ? appraisalRecord?.lastpromotion
        : "-",
    },
  ];

  const personalDet = [
    {
      data: "Salutation",
      value: appraisalRecord?.salutation || "-",
    },

    {
      data: "Date Of Birth",
      value: appraisalRecord?.dateofbirth ? appraisalRecord?.dateofbirth : "-",
    },
    {
      data: "Gender",
      value: appraisalRecord?.gender
        ? appraisalRecord?.gender.charAt(0).toUpperCase() +
          appraisalRecord?.gender.slice(1)
        : "-",
    },
    {
      data: "Marital Status",
      value: appraisalRecord?.maritalstatus
        ? appraisalRecord?.maritalstatus.charAt(0).toUpperCase() +
          appraisalRecord?.maritalstatus.slice(1)
        : "-",
    },
    {
      data: "No. of Dependants",
      value: appraisalRecord?.dependent || "-",
    },
    {
      data: "Greetings",
      value: appraisalRecord?.greetings || "-",
    },

    {
      data: "Phone No",
      value: appraisalRecord?.phoneno || "-",
    },
    {
      data: "Email Address",
      value: appraisalRecord?.userid || "-",
    },
    {
      data: "Postal Address",
      value: appraisalRecord?.postaladdress || "-",
    },

    {
      data: "Emergency Contact Name",
      value: appraisalRecord?.emergencycontactname || "-",
    },
    {
      data: "Emergency Contact Number",
      value: appraisalRecord?.emergencycontactnumber || "-",
    },
  ];

  const mergedHistoryData = historyData
    ?.filter(
      (item) =>
        item.contractid === appraisalDetails?.contractid &&
        item.contractstatus !== "draft"
    )
    ?.reduce((acc, item) => {
      Object.entries(item).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
      });
      return acc;
    }, {});

  const historydate = mergedHistoryData?.accepteddeclinedon;

  const contractStatus = appraisalDetails?.contractstatus;
  let dateLabel = "Accepted on: -";
  if (
    contractStatus === "created" ||
    contractStatus === "resend" ||
    contractStatus === "updated"
  ) {
    dateLabel = dayjs(historydate).isValid()
      ? `Created on: ${dayjs(historydate).format("D MMM YYYY, hh:mm A")}`
      : "Created on: -";
  } else if (contractStatus === "accepted") {
    dateLabel = dayjs(historydate).isValid()
      ? `Accepted on: ${dayjs(historydate).format("D MMM YYYY, hh:mm A")}`
      : "Accepted on: -";
  } else if (contractStatus === "declined") {
    dateLabel = dayjs(historydate).isValid()
      ? `Declined on: ${dayjs(historydate).format("D MMM YYYY, hh:mm A")}`
      : "Declined on: -";
  }

  const jobDescriptionDetails = userList
    ?.find((val) => val?.userid === appraisalDetails?.apraiseemailid)
    ?.appraisalInformation?.filter(
      (item) => item?.roletype === appraisalDetails?.roletype
    );

  const viewJobDescription = async () => {
    if (
      !jobDescriptionDetails[0]?.jobDescriptionId ||
      !jobDescriptionDetails[0]?.jobdescriptionFileName
    ) {
      message.warning("User has not created a Job Description.");
      return;
    }
    const token = window.localStorage.getItem("token") || "";
    try {
      setLoader(true);
      const response = await axios.get(
        "https://h8gw6wo6o3.execute-api.us-west-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: {
            jobdescriptionid: jobDescriptionDetails[0]?.jobDescriptionId,
            filename: jobDescriptionDetails[0]?.jobdescriptionFileName,
          },
          headers: { Tymeplusjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        setPdfUrl(response.data.url);
        setIsPdfModalOpen(true);
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
        setLoader(false);
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div style={{ marginBottom: "100px" }}>
      <StyledDiv>
        <Spin spinning={loader}>
          <SegmentWrap
            options={segmentedData.map((item) => ({
              label: item?.roletype,
              value: item?.contractid,
            }))}
            value={selectedSegment}
            onChange={(value) => {
              setSelectedSegment(value);
            }}
          />

          <div className="Appraisal_first_tabledata">
            <span
              className="appraisalTitle cursor-pointer"
              // onClick={() =>
              //   history.push("/performancemanagement", {
              //     tabId: "managerappraisal",
              //   })
              // }
              onClick={() =>
                history.push({
                  pathname: "/performancemanagement",
                  state: {
                    tabId: "managerappraisal",
                    selectedItem: "performance-management",
                  },
                })
              }
            >
              Performance Management
            </span>{" "}
            <RightOutlined className="Right_outlined" />
            {/* <span
                        className="appraisalSubTitle cursor-pointer"
                        onClick={() =>
                          history.push(`/viewmyteamAppraisal/${id}`, {
                            tabId: tab,
                            appraisalname: appraisalname,
                          })
                        }
                      >
                        {appraisalname || "---"},
                      </span> */}
            <span> {appraisalRecord?.fullname || "-"}</span>
          </div>

          {selectedSegment === appraisalDetails?.contractid &&
          (appraisalDetails?.contractstatus === "attended" ||
            appraisalDetails?.contractstatus === "draft" ||
            appraisalDetails?.contractstatus === "reviewed" ||
            appraisalDetails?.contractstatus === "accepted") ? (
            <>
              <h4 className="mt-2">
                {appraisalDetails?.contractstatus === "accepted"
                  ? "Awaiting Appraisee Response"
                  : appraisalDetails?.contractstatus === "attended" ||
                    appraisalDetails?.contractstatus === "draft"
                  ? "Attended"
                  : appraisalDetails?.contractstatus === "reviewed"
                  ? "closed"
                  : ""}
              </h4>
              <div className="mb-2 d-flex justify-content-between align-items-center">
                <p className="employee_detail_headings mb-0">
                  <b>Work Information:</b>
                </p>
              </div>
              <Row className="employee_work_info_box">
                {WorkInfoDetails.map((data, index) => {
                  return (
                    <Col xs={12} lg={6} key={index}>
                      <StyledRow className="my-1 employee_work_info">
                        <Col
                          sm={12}
                          md={6}
                          className={`my-1 ${
                            data.data === "Office Competency Supervisor" ||
                            data.data === "Regional Competency Supervisor"
                              ? "text-wrap"
                              : "text-nowrap"
                          }`}
                        >
                          <b className="label_Color">{data.data}: </b>
                        </Col>
                        <Col
                          sm={12}
                          md={6}
                          className="my-1 employess_detail_values text-wrap"
                        >
                          <b className="label_value_Color">{data.value}</b>
                        </Col>
                      </StyledRow>
                    </Col>
                  );
                })}
              </Row>
              <br />
              <div className="mb-2 d-flex justify-content-between align-items-center">
                <p className="employee_detail_headings mb-0">
                  <b>Personal Information:</b>
                </p>
              </div>
              <Row className="employee_work_info_box">
                {personalDet.map((data, index) => {
                  return (
                    <Col xs={12} lg={6} key={index}>
                      <StyledRow className="my-1 employee_work_info">
                        <Col sm={12} md={6} className="my-1 text-wrap">
                          <b className="label_Color">{data.data}: </b>
                        </Col>
                        <Col
                          sm={12}
                          md={6}
                          className="my-1 employess_detail_values text-wrap"
                        >
                          <b className="label_value_Color">{data.value}</b>
                        </Col>
                      </StyledRow>
                    </Col>
                  );
                })}
              </Row>

              <h6>
                {appraisalDetails?.appraisalInformation?.[0]?.roletype} Role
              </h6>
              <p>
                Describe specific Strategic Objectives or other developmental
                activities to be undertaken by Appraisee during the upcoming
                appraisal period
              </p>

              {technicalAssessmentData?.length > 0 && (
                <div className="table-container mb-2">
                  <h6>Strategic Objectives</h6>
                  <StyledTable
                    className="mb-3"
                    columns={getColumns(
                      "Strategic Objectives aligned to Organisational Strategy for the upcoming appraisal period"
                    )}
                    dataSource={technicalAssessmentData}
                    pagination={false}
                  />
                </div>
              )}
              {rolledOverData?.length > 0 && (
                <div className="table-container mt-2 mb-2">
                  <div className="d-flex justify-content-between align-items-cente">
                    <h6>Rollover Responsibility from Previous Appraisal</h6>
                    <p
                      className="pb-0"
                      onClick={() => viewJobDescription()}
                      style={{
                        color: "#1890ff",
                        textDecoration: "underline",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                    >
                      Job Description
                    </p>
                  </div>
                  <StyledTable
                    className="mb-3 mt-0"
                    columns={getColumns(
                      "Objectives that Rolled over from Previous Appraisal Period"
                    )}
                    dataSource={rolledOverData}
                    pagination={false}
                  />
                </div>
              )}
              {upcomingData?.length > 0 && (
                <div className="table-container mt-2 mb-2">
                  <div className="d-flex justify-content-between align-items-cente">
                    <h6>
                      Objectives from JD for the Upcoming Appraisal Period
                    </h6>
                    <p
                      className="pb-0"
                      onClick={() => viewJobDescription()}
                      style={{
                        color: "#1890ff",
                        textDecoration: "underline",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                    >
                      Job Description
                    </p>
                  </div>
                  <StyledTable
                    className="mt-0"
                    columns={getColumns(
                      "Target Objectives aligned to Organisational Strategy for the upcoming appraisal period"
                    )}
                    dataSource={upcomingData}
                    pagination={false}
                  />
                </div>
              )}
              <div style={{ marginTop: "35px" }}>
                {softSkillData?.length > 0 &&
                  appraisalDetails?.roletype === "Primary" && (
                    <div className="table-container mt-2 mb-2">
                      <h6>Individual ( Soft skils ) Assessment / BDO VALUES</h6>
                      <StyledTable
                        columns={dataColumns}
                        dataSource={softSkillData}
                        pagination={false}
                      />
                    </div>
                  )}
              </div>
              <img
                src={user}
                alt="Floating User Icon"
                style={{
                  position: "fixed",
                  bottom: "10px",
                  right: "50px",
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  zIndex: 1000,
                  cursor: "pointer",
                }}
                onClick={showModal}
              />
              <ButtonFilled
                style={{
                  position: "fixed",
                  bottom: "30px",
                  left: "320px",
                  borderRadius: "25px",
                  cursor: "pointer",
                  zIndex: 1000,
                }}
                onClick={() => setIsModalOpen(true)}
              >
                {dayjs(
                  mergedHistoryData?.contractstatus === "reviewed"
                    ? mergedHistoryData?.reviewedon
                    : mergedHistoryData?.contractstatus === "attended"
                    ? mergedHistoryData?.attendedon
                    : mergedHistoryData?.accepteddeclinedon
                ).isValid()
                  ? `${
                      mergedHistoryData?.contractstatus === "reviewed"
                        ? "Closed on:"
                        : mergedHistoryData?.contractstatus === "attended"
                        ? "Attended on:"
                        : mergedHistoryData?.contractstatus === "accepted"
                        ? "Accepted on:"
                        : mergedHistoryData?.contractstatus === "declined"
                        ? "Declined on:"
                        : mergedHistoryData?.contractstatus === "resend"
                        ? "Resent on:"
                        : mergedHistoryData?.contractstatus === "updated"
                        ? "Updated on:"
                        : mergedHistoryData?.contractstatus === "created"
                        ? "Created on:"
                        : "Attended on:"
                    } ${dayjs(
                      mergedHistoryData?.contractstatus === "reviewed"
                        ? mergedHistoryData?.reviewedon
                        : mergedHistoryData?.contractstatus === "attended"
                        ? mergedHistoryData?.attendedon
                        : mergedHistoryData?.contractstatus === "accepted"
                        ? mergedHistoryData?.accepteddeclinedon
                        : mergedHistoryData?.contractstatus === "declined"
                        ? mergedHistoryData?.accepteddeclinedon
                        : mergedHistoryData?.contractstatus === "resend"
                        ? mergedHistoryData?.updatedon
                        : mergedHistoryData?.contractstatus === "updated"
                        ? mergedHistoryData?.updatedon
                        : mergedHistoryData?.contractstatus === "created"
                        ? mergedHistoryData?.createdon
                        : mergedHistoryData?.attendedon
                    )
                      .utc()
                      .tz("Africa/Nairobi")
                      .format("D MMM YYYY, hh:mm A")}`
                  : "Accepted on : -"}
              </ButtonFilled>
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 300,
                }}
              >
                <FolderIcon
                  style={{ width: 200, height: 200, marginBottom: 10 }}
                />{" "}
                <p style={{ fontSize: 18, color: "#999", textAlign: "center" }}>
                  {" "}
                  No Data
                </p>
              </div>
            </>
          )}
          <EmployeeInfo
            isModalVisible={isModalVisible}
            handleCancelModal={handleCancelModal}
            selectedEmployee={selectedEmployee}
          />

          <Modal
            open={isPdfModalOpen}
            onCancel={() => setIsPdfModalOpen(false)}
            footer={null}
            width={1000}
            centered
            bodyStyle={{ height: "80vh", padding: 0 }}
          >
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                title="PDF Preview"
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            ) : (
              <p style={{ textAlign: "center", paddingTop: "40%" }}>
                Loading...
              </p>
            )}
          </Modal>
          <AppraisalHistory
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            appraiseeid={appraisalRecord[0]?.userid}
            data={historyData?.filter(
              (item) =>
                item.contractid === appraisalDetails?.contractid &&
                item.contractstatus !== "draft"
            )}
            title="Contract History"
          />
        </Spin>
      </StyledDiv>
    </div>
  );
};

const StyledRow = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: center;
  .my-1 {
    display: flex;
    word-wrap: break-word;
  }
  .graybg {
    background-color: #f6f6f6;
  }
  .label_Color {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3019;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .label_value_Color {
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #1f243b;
  }
`;

export default AwaitingAppraiseeRespons;
